

const steps = [
  {
    title: "Kontakt",
    text: "Skontaktuj się z nami telefonicznie lub mailowo. Odpowiadamy w ciągu 1–2 dni roboczych, najczęściej jeszcze tego samego dnia."
  },
  {
    title: "Omówienie zakresu prac",
    text: "Ustalamy zakres prac takich jak czyszczenie działek, mulczowanie, prace ziemne lub zakładanie ogrodów."
  },
  {
    title: "Wycena",
    text: "Na podstawie informacji przygotowujemy wycenę. W przypadku dodatkowych prac ustalamy je na miejscu."
  },
  {
    title: "Potwierdzenie współpracy",
    text: "Z firmami najczęściej podpisujemy umowę. W przypadku klientów prywatnych często wystarcza potwierdzenie mailowe lub ustna umowa."
  },
  {
    title: "Realizacja",
    text: "Po akceptacji wyceny przystępujemy do realizacji prac ogrodniczych lub ziemnych."
  }
];

export default function ContactTimeline() {
  return (
    <section className="p-6 lg:px-24 lg:py-16 bg-white">

      <div className="max-w-6xl mx-auto">

        <div className="mb-12 flex flex-col items-center">
          <h2 className="text-3xl lg:text-5xl color-green font-semibold">
            Jak wygląda współpraca
          </h2>

          <p className="text-gray-600 mt-4 max-w-2xl">
            Realizujemy usługi takie jak <strong>mulczowanie Pomorskie</strong>,
            <strong> mulczowanie Trójmiasto</strong> oraz
            <strong> czyszczenie działek Pomorskie</strong>.
            Działamy sprawnie i przejrzyście — od pierwszego kontaktu po realizację.
          </p>
        </div>


        <div className="relative border-l-2 border-green-700 pl-8">

          {steps.map((step, index) => (
            <div key={index} className="mb-10">

              <div className="absolute -left-[10px] w-5 h-5 bg-green-700 rounded-full border-4 border-white"></div>

              <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 shadow-sm hover:bg-gray-100 transition">

                <h3 className="text-xl font-semibold color-green mb-2">
                  {step.title}
                </h3>

                <p className="text-gray-600">
                  {step.text}
                </p>

              </div>

            </div>
          ))}

        </div>


        {/* OBSZAR DZIAŁANIA */}

        <div className="mt-20 mb-12 flex flex-col items-center">

          <h2 className="text-3xl lg:text-5xl color-green font-semibold mb-6">
            Obszar działania
          </h2>

          <p className="text-gray-600 max-w-3xl mb-8">
            Działamy na terenie całego <strong>województwa pomorskiego</strong>,
            w tym na obszarze <strong>Trójmiasta</strong> oraz w okolicznych
            miejscowościach. Realizujemy usługi takie jak
            <strong> mulczowanie pomorskie</strong>,
            <strong> mulczowanie trójmiasto</strong> oraz
            <strong> czyszczenie działek pomorskie</strong>.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">

            {[
              "Gdańsk",
              "Gdynia",
              "Sopot",
              "Rumia",
              "Kartuzy",
              "Kościerzyna",
              "Wejherowo"
            ].map((city) => (

              <div
                key={city}
                className="bg-gray-50 border border-gray-100 rounded-xl p-4 text-center font-semibold text-gray-700 hover:bg-gray-100 transition"
              >
                {city}
              </div>

            ))}

          </div>

        </div>

      </div>

    </section>
  );
}